module.exports = __webpack_public_path__ + "static/media/ok-check.bf79090f.svg";